"use client";

import { useAuth } from "@/lib/auth/context";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Loader2 } from "lucide-react";

export default function Home() {
  const { user, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading) {
      if (user?.role) {
        router.push(`/${user.role}`);
      } else {
        router.push("/auth/signin");
      }
    }
  }, [user, isLoading, router]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-studio-dark">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-studio-accent" />
        <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-studio-secondary animate-pulse">
          Redirecting to Portal
        </span>
      </div>
    </main>
  );
}
